@if ((serviceNowCaseError$ | async) !== null) {
  <error-message
    [error]="serviceNowCaseError$ | async"
    [page]="'Service Now Report'">
  </error-message>
}
@if (!(isMobile$ | async) && !(serviceNowCaseError$ | async)) {
  <mat-dialog-content class="service-now-report__wrapper">
    <div class="service-now-report__header">
      CARES Report #{{(serviceNowCase$ | async).number}}
      <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Close" (click)="closeReport()"><mat-icon class="service-now-report__close-report">close</mat-icon></button>
    </div>
    @if (serviceNowCaseLoading$ | async) {
      <div
        class="service-now-report__loading"
        [cfaLoading]="true">
      </div>
    }
    @if (!(serviceNowCaseLoading$ | async)) {
      <div fxLayout="row" fxLayoutGap="10">
        <div fxFlex="30%">
          <div class="service-now-report__personal-details">
            <div>Customer: {{(serviceNowCase$ | async).name}}</div>
            <div>Phone: {{(serviceNowCase$ | async).phone}}</div>
            <div>Email: <span [ngClass]="{'service-now-report__no-email-text': !(serviceNowCase$ | async).email || (serviceNowCase$ | async).email === 'N/A'}">{{(serviceNowCase$ | async).email && (serviceNowCase$ | async).email !== 'N/A' ? (serviceNowCase$ | async).email : noEmailText}}</span></div>
          </div>
          <div class="service-now-report__report-details-container">
            <div class="service-now-report__report-details-header">Contact Instruction</div>
            <div>Contact via {{(serviceNowCase$ | async).contactMethod}}</div>
            <div [ngClass]="{'service-now-report__red-text': (serviceNowCase$ | async).isP1}">
              Priority {{(serviceNowCase$ | async).priority}}
            </div>
            <div>{{(serviceNowCase$ | async).contactRequirement}}</div>
            <hr class="service-now-report__divider">
            <div class="service-now-report__report-details-header">Occurred On</div>
            <div>{{(serviceNowCase$ | async).incidentDate}}</div>
            <div class="service-now-report__report-details-header">Contacted On</div>
            @if (!(serviceNowCase$ | async).lastContactDate) {
              <div>{{(serviceNowCase$ | async).contactDate}}</div>
            }
            @if ((serviceNowCase$ | async).lastContactDate) {
              <div>{{(serviceNowCase$ | async).lastContactDate}}</div>
            }
            <div class="service-now-report__report-details-header">Report Routed On</div>
            @if (!(serviceNowCase$ | async).lastAssignmentDate) {
              <div>{{(serviceNowCase$ | async).assignmentDate}}</div>
            }
            @if ((serviceNowCase$ | async).lastAssignmentDate) {
              <div>{{(serviceNowCase$ | async).lastAssignmentDate}}</div>
            }
            <hr class="service-now-report__divider">
            <div class="service-now-report__report-details-header">Customer Contact History</div>
            <div class="service-now-report__report-details-header">(past 365 days)</div>
            <div>Prior complaints to any Chick-fil-A: {{(serviceNowCase$ | async).priorContactsToAnyCfaLocation}}</div>
            <div>Prior complaints to this Chick-fil-A: {{(serviceNowCase$ | async).priorContactsToThisLocation}}</div>
            <hr class="service-now-report__divider">
            <div class="service-now-report__report-details-header">Location Information</div>
            <div>Number: {{(serviceNowCase$ | async).locationNumber}}</div>
            <div class="service-now-report__report-details-header">Cares Support Tier</div>
            @if ((serviceNowCase$ | async).supportTier) {
              <div>{{(serviceNowCase$ | async).supportTier.name}}</div>
            }
          </div>
        </div>
        <div fxFlex="70%">
          <div class="service-now-report__high-priority-details">
            <div>To: {{(serviceNowCase$ | async).recipientTo}}</div>
            <div>CC: {{(serviceNowCase$ | async).recipientCc}}</div>
          </div>
          <div class="service-now-report__report-history-container">
            <div class="service-now-report__report-details-header">Action Guidance for Restaurant</div>
            <div [innerHTML]="(serviceNowCase$ | async).restaurantActionGuidance"></div>
            <hr class="service-now-report__divider">
            <div fxLayout="row" fxLayoutGap="10">
              <div fxFlex="25%">
                <div class="service-now-report__report-details-header">Order Placed Via</div>
                <div>{{(serviceNowCase$ | async).orderMethod}}</div>
              </div>
              <div fxFlex="25%">
                <div class="service-now-report__report-details-header">Order Received Via</div>
                <div>{{(serviceNowCase$ | async).fulfillmentMethod}}</div>
              </div>
              <div fxFlex="25%">
                <div class="service-now-report__report-details-header">Receipt?</div>
                @if ((serviceNowCase$ | async).isReceiptAvailable) {
                  <div>YES</div>
                }
                @if (!(serviceNowCase$ | async).isReceiptAvailable) {
                  <div>NO</div>
                }
              </div>
              <div fxFlex="25%">
                <div class="service-now-report__report-details-header">Order Number</div>
                <div>{{(serviceNowCase$ | async).orderNumber}}</div>
              </div>
            </div>
            <hr class="service-now-report__divider">
            <div class="service-now-report__report-details-header">Customer Comments</div>
            <div [innerHTML]="(serviceNowCase$ | async).comments"></div>
            <hr class="service-now-report__divider">
            <div class="service-now-report__report-details-header">Approved Response Sent To Customer</div>
            <div [innerHTML]="(serviceNowCase$ | async).responseSentToCustomer"></div>
            <hr class="service-now-report__divider">
            <div fxLayout="row">
              <div fxFlex="45%">
                <div class="service-now-report__report-details-header">Resolution Status</div>
                <div [innerHTML]="(serviceNowCase$ | async).resolutionStatus"></div>
                @if ((serviceNowCase$ | async).reportReasonUnableToResolve) {
                  <div>
                    Reasons CARES unable to resolve: {{(serviceNowCase$ | async).reportReasonUnableToResolve}}
                  </div>
                }
              </div>
              <div fxFlex="2%">
                <div class="service-now-report__vertical-divider"></div>
              </div>
              <div fxFlex="45%" class="service-now-report__care-status">
                <div class="service-now-report__report-details-header">Care Offer Status</div>
                <div [innerHTML]="(serviceNowCase$ | async).offerStatus"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!(serviceNowCaseLoading$ | async)) {
      <div class="service-now-report__button-container">
        @if ((serviceNowCase$ | async).isP1) {
          <button mat-raised-button
            class="service-now-report__acknowledge-report-button"
            [disabled]="(serviceNowCase$ | async).acknowledgment || (selectedReport$ | async).isResolved
                        || (readOnlyUser$ | async)"
            (click)="acknowledgeReport()">
            Acknowledge Report
          </button>
        }
        <button mat-raised-button
          class="service-now-report__reassign-report-button"
          [disabled]="(selectedReport$ | async).isResolved || (readOnlyUser$ | async)"
          (click)="goToReassignDialog()">
          Reassign - Wrong Restaurant
        </button>
        @if (!(serviceNowCase$ | async).isClosed) {
          <button
            mat-button
            class="service-now-report__action-button"
            data-testid="action-button"
            [disabled]="((serviceNowCase$ | async).isP1 && !((serviceNowCase$ | async).acknowledgment))
                        || (readOnlyUser$ | async)"
            (click)="goToActionSelection()">
            Action
          </button>
        }
        @if ((serviceNowCase$ | async).isClosed) {
          <button
            mat-button
            class="service-now-report__action-button"
            data-testid="reopen-button"
            [disabled]="readOnlyUser$ | async"
            (click)="reopenReport()">
            Reopen
          </button>
        }
      </div>
    }
  </mat-dialog-content>
}
@if ((isMobile$ | async) && !(serviceNowCaseError$ | async)) {
  <mat-dialog-content class="service-now-report__mobile-wrapper">
    <div class="service-now-report__header">
      CARES Report #{{(serviceNowCase$ | async).number}}
      <button type="button" class="cfa-plain-button cfa-plain-button--inline" aria-label="Close" (click)="closeReport()"><mat-icon class="service-now-report__close-report">close</mat-icon></button>
    </div>
    @if (serviceNowCaseLoading$ | async) {
      <div
        class="service-now-report__loading"
        [cfaLoading]="true">
      </div>
    }
    @if (!(serviceNowCaseLoading$ | async)) {
      <div class="service-now-report__mobile-body">
        <div class="service-now-report__personal-details">
          <div>Customer: {{(serviceNowCase$ | async).name}}</div>
          <div>Phone: {{(serviceNowCase$ | async).phone}}</div>
          <div>Email: <span [ngClass]="{'service-now-report__no-email-text': !(serviceNowCase$ | async).email || (serviceNowCase$ | async).email === 'N/A'}">{{(serviceNowCase$ | async).email && (serviceNowCase$ | async).email !== 'N/A' ? (serviceNowCase$ | async).email : noEmailText}}</span></div>
          <div>To: {{(serviceNowCase$ | async).recipientTo}}</div>
          <div>CC: {{(serviceNowCase$ | async).recipientCc}}</div>
        </div>
        <div class="service-now-report__report-details-container">
          <div class="service-now-report__report-details-header">Contact Instruction</div>
          <div>Contact via {{(serviceNowCase$ | async).contactMethod}}</div>
          <div [ngClass]="{'service-now-report__red-text': (serviceNowCase$ | async).isP1}">
            Priority {{(serviceNowCase$ | async).priority}}
          </div>
          <div>{{(serviceNowCase$ | async).contactRequirement}}</div>
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Occurred On</div>
          <div>{{(serviceNowCase$ | async).incidentDate}}</div>
          <div class="service-now-report__report-details-header">Contacted On</div>
          @if (!(serviceNowCase$ | async).lastContactDate) {
            <div>{{(serviceNowCase$ | async).contactDate}}</div>
          }
          @if ((serviceNowCase$ | async).lastContactDate) {
            <div>{{(serviceNowCase$ | async).lastContactDate}}</div>
          }
          <div class="service-now-report__report-details-header">Report Routed On</div>
          @if (!(serviceNowCase$ | async).lastAssignmentDate) {
            <div>{{(serviceNowCase$ | async).assignmentDate}}</div>
          }
          @if ((serviceNowCase$ | async).lastAssignmentDate) {
            <div>{{(serviceNowCase$ | async).lastAssignmentDate}}</div>
          }
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Customer Contact History</div>
          <div class="service-now-report__report-details-header">(past 365 days)</div>
          <div>Prior complaints to any Chick-fil-A: {{(serviceNowCase$ | async).priorContactsToAnyCfaLocation}}</div>
          <div>Prior complaints to this Chick-fil-A: {{(serviceNowCase$ | async).priorContactsToThisLocation}}</div>
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Location Information</div>
          <div>Number: {{(serviceNowCase$ | async).locationNumber}}</div>
          <div class="service-now-report__report-details-header">Cares Support Tier</div>
          @if ((serviceNowCase$ | async).supportTier) {
            <div>{{(serviceNowCase$ | async).supportTier.name}}</div>
          }
        </div>
        <div class="service-now-report__report-history-container-mobile">
          <div class="service-now-report__report-details-header">Action Guidance for Restaurant</div>
          <div [innerHTML]="(serviceNowCase$ | async).restaurantActionGuidance"></div>
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Order Placed Via</div>
          <div>{{(serviceNowCase$ | async).orderMethod}}</div>
          <div class="service-now-report__report-details-header">Order Received Via</div>
          <div>{{(serviceNowCase$ | async).fulfillmentMethod}}</div>
          <div class="service-now-report__report-details-header">Receipt?</div>
          @if ((serviceNowCase$ | async).isReceiptAvailable) {
            <div>YES</div>
          }
          @if (!(serviceNowCase$ | async).isReceiptAvailable) {
            <div>NO</div>
          }
          <div class="service-now-report__report-details-header">Order Number</div>
          <div>{{(serviceNowCase$ | async).orderNumber}}</div>
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Customer Comments</div>
          <div class="service-now-report__report-details-mobile-overflow"
          [innerHTML]="(serviceNowCase$ | async).comments"></div>
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Approved Response Sent To Customer</div>
          <div class="service-now-report__report-details-mobile-overflow"
          [innerHTML]="(serviceNowCase$ | async).responseSentToCustomer"></div>
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Resolution Status</div>
          <div [innerHTML]="(serviceNowCase$ | async).resolutionStatus"></div>
          @if ((serviceNowCase$ | async).reportReasonUnableToResolve) {
            <div>
              Reasons CARES unable to resolve: {{(serviceNowCase$ | async).reportReasonUnableToResolve}}
            </div>
          }
          <hr class="service-now-report__divider">
          <div class="service-now-report__report-details-header">Care Offer Status</div>
          <div [innerHTML]="(serviceNowCase$ | async).offerStatus"></div>
        </div>
      </div>
    }
    @if (!(serviceNowCaseLoading$ | async)) {
      <div class="service-now-report__button-container-mobile">
        @if ((serviceNowCase$ | async).isP1) {
          <button mat-raised-button
            class="service-now-report__acknowledge-report-button-mobile"
            [disabled]="(serviceNowCase$ | async).acknowledgment || (selectedReport$ | async).isResolved
                        || (readOnlyUser$ | async)"
            (click)="acknowledgeReport()">
            Acknowledge Report
          </button>
        }
        <button mat-raised-button
          class="service-now-report__reassign-report-button-mobile"
          [disabled]="(selectedReport$ | async).isResolved || (readOnlyUser$ | async)"
          (click)="goToReassignDialog()">
          Reassign - Wrong Restaurant
        </button>
        @if (!(serviceNowCase$ | async).isClosed) {
          <button
            mat-button
            class="service-now-report__action-button-mobile"
            data-testid="action-button"
            [disabled]="((serviceNowCase$ | async).isP1 && !((serviceNowCase$ | async).acknowledgment))
                        || (readOnlyUser$ | async)"
            (click)="goToActionSelection()">
            Action
          </button>
        }
        @if ((serviceNowCase$ | async).isClosed) {
          <button
            mat-button
            class="service-now-report__action-button-mobile"
            data-testid="reopen-button"
            [disabled]="readOnlyUser$ | async"
            (click)="reopenReport()">
            Reopen
          </button>
        }
      </div>
    }
  </mat-dialog-content>
}
